/**
 * 初始化站点。
 * 
*/


import axios from 'axios';
import Container from './container';
import Assert from './assert';
import {formatDate,randomNumber } from './utils';

const site = window.siteInit.envVar();
window.console.log('siteInit:%s',JSON.stringify(site));
Assert.status(typeof site === 'object','不正常的环境变量,' + typeof site + ',' +JSON.stringify(site))

const fun1 = {
    showWxServerAccountAppid : ()=>{
        return site.wxServerAccountAppid;
    },

    showApiPath : ()=>{
        return site.api;
    },

    showSchoolApiPath : ()=>{
        return site.schoolApi;
    },

    showSiteBase :()=>{
        return site.base;
    },

    showHome : ()=>{
        return site.home;
    },

    showServerWxWebAuthDomain : ()=>{
        return site.serverWxWebAuthDomain;
    },

    fillClientId :(headers)=>{
        let clientId = Container.localGet('clientId');
        if(!/^\d{27}$/.test(clientId)){
            clientId = `${formatDate('yyyyMMddHHmmssS')}${randomNumber(10)}`;
            Container.localSave('clientId', clientId);
        }
        headers['x-client-id'] = clientId;
    }
}

export default {...fun1};


// WEBPACK FOOTER //
// ./src/utils/siteEnv.js